import { FC } from 'react'
import { ETAPAS_COMERCIAIS, ETAPA_COMERCIAL_LABEL, EtapaComercial } from '@/types/statusReserva'
import { formatBRL, formatBRLCurto } from './canais'
import { COR_ETAPA_MARCA } from './FunilEtapas'
import { GraficoColunas } from './GraficoColunas'
import { LegendaGrafico, LegendaGraficoProps } from './LegendaGrafico'

export interface VolumePorEtapaProps {
  /** `pipeline.valorPorEtapaComercial` do resumo — a altura de cada coluna. */
  valorPorEtapa: Record<string, number> | undefined
  /** Clique numa etapa (mesmo destino do "Meu funil"). */
  aoClicar?: (etapa: EtapaComercial) => void
  altura?: number
  /** Legenda (L13): unidade, período, critério e o aviso de ganho estimado (L14). */
  legenda?: LegendaGraficoProps
}

/**
 * Volume (R$) por etapa comercial (VC-01): par do `FunilEtapas`, com a mesma ordem e as
 * mesmas cores, mas a altura da coluna é o valor estimado das reservas em cada etapa.
 * O número vem pronto do `/v1/dashboard/resumo`; nada é somado aqui.
 */
export const VolumePorEtapa: FC<VolumePorEtapaProps> = ({ valorPorEtapa, aoClicar, altura, legenda }) => (
  <>
    <GraficoColunas
      altura={altura}
      formatoValor={formatBRLCurto}
      aoClicar={aoClicar ? (chave) => aoClicar(chave as EtapaComercial) : undefined}
      itens={ETAPAS_COMERCIAIS.map((etapa) => {
        const valor = Number(valorPorEtapa?.[etapa] ?? 0)
        return {
          chave: etapa,
          rotulo: ETAPA_COMERCIAL_LABEL[etapa],
          valor,
          cor: COR_ETAPA_MARCA[etapa],
          tooltip: `${ETAPA_COMERCIAL_LABEL[etapa]}: ${formatBRL(valor)}`,
        }
      })}
    />
    {legenda && <LegendaGrafico {...legenda} />}
  </>
)

export default VolumePorEtapa
